// extracted by mini-css-extract-plugin
export default {"container":"HeadToHeadMarket_container__3qil2","odds":"HeadToHeadMarket_odds__fgEnb","oddsbutton":"HeadToHeadMarket_oddsbutton__4h6kO"};